import Image from 'next/image'
import React from 'react'
import { FacebookOutlined } from '@ant-design/icons'

const FotterComponent = () => {
    return (
        <footer className="bg-[#041a37] text-[#aebed2] py-10 px-4 sm:px-6 lg:px-8">
            <div className="max-w-7xl mx-auto">
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8">
                    {/* Brand */}
                    <div className="sm:col-span-2 md:col-span-1">
                        <div className="flex items-center gap-2 mb-3">
                            <Image
                                src="/brand/logo192px.png"
                                alt="Customs Solution Logo"
                                width={42}
                                height={42}
                                className="rounded-lg"
                            />
                            <div className="text-white font-extrabold text-sm leading-tight">
                                CUSTOMS SOLUTION
                                <span className="block text-[10px] font-medium text-[#aebed2]">
                                    Simplifying Global Customs Clearance
                                </span>
                            </div>
                        </div>
                        <p className="text-xs max-w-[280px]">
                            All-in-one web platform for HS code search, duty & tax calculation, SROs, policies and customs references.
                        </p>
                    </div>

                    {/* Product */}
                    <div>
                        <h4 className="text-sm text-white font-semibold mb-3">Product</h4>
                        <ul className="space-y-1.5 text-xs">
                            <li><a href="#features" className="hover:text-white transition-colors">Features</a></li>
                            <li><a href="#pricing" className="hover:text-white transition-colors">Pricing</a></li>
                            <li><a href="/auth/login" className="hover:text-white transition-colors">Sign In</a></li>
                            <li><a href="/auth/register" className="hover:text-white transition-colors">Subscribe</a></li>
                            <li><a href="#" className="hover:text-white transition-colors">Updates</a></li>
                        </ul>
                    </div>

                    {/* Resources */}
                    <div>
                        <h4 className="text-sm text-white font-semibold mb-3">Resources</h4>
                        <ul className="space-y-1.5 text-xs">
                            <li><a href="#" className="hover:text-white transition-colors">SROs</a></li>
                            <li><a href="#" className="hover:text-white transition-colors">Import Policy</a></li>
                            <li><a href="#" className="hover:text-white transition-colors">Export Policy</a></li>
                            <li><a href="#" className="hover:text-white transition-colors">Customs Act & Rules</a></li>
                            <li><a href="#" className="hover:text-white transition-colors">Help Center</a></li>
                        </ul>
                    </div>

                    {/* Contact */}
                    <div>
                        <h4 className="text-sm text-white font-semibold mb-3">Contact Us</h4>
                        <ul className="space-y-1.5 text-xs">
                            <li>☎ <strong className="text-white">+880 1976632527</strong></li>
                            <li>✉ bdcustomssolution@gmail.com</li>
                            <li>⌖ Gause-pak Bhaban, Mitijheel, Dhaka, Bangladesh</li>
                        </ul>
                    </div>
                </div>

                {/* Copyright */}
                <div className="border-t border-white/10 mt-8 pt-4 flex flex-col sm:flex-row justify-between text-xs">
                    <span>© 2026 Customs Solution. All rights reserved.</span>
                    <span>www.bdcustomssolution.com</span>
                </div>
            </div>
        </footer>
    )
}

export default FotterComponent